module.exports = __webpack_public_path__ + "img/S9016-IL.633c7108.jpg";